"use client";

import { ArrowUpLeft } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function BathroomHero() {
  const eyebrow = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const headline = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.2
  });
  const paragraph = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.2
  });
  const cta = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const image = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const caption = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="20825" id="bathroom-remodel-services-in-lakeland-and-polk-county" className="bg-background text-foreground py-32 md:py-44 lg:py-56">
      <div className="mx-auto w-full max-w-[1440px] px-6 md:px-12 lg:px-[120px]">
        <div className="grid grid-cols-12">
          <div className="col-span-12 md:col-start-2 md:col-span-10 text-center">
            {}
            <div ref={eyebrow.ref} className={`font-default italic text-sm md:text-[0.9375rem] text-muted-foreground transition-all duration-700 ease-out ${eyebrow.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`}>Bathroom Remodel Service Areas Near Lakeland, FL</div>

            {}
            <h1 ref={headline.ref} style={{
            lineHeight: 1.02,
            letterSpacing: "-0.025em"
          }} className={`font-default font-normal mt-16 text-[clamp(2.75rem,6.4vw,5.5rem)] text-foreground transition-all duration-700 ease-out delay-100 ${headline.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`}>
              <span>Bathroom Remodel Service Areas Near Lakeland, FL</span>
              
              
            </h1>

            {}
            <p ref={paragraph.ref} style={{
            lineHeight: 1.65,
            letterSpacing: "-0.005em"
          }} className={`mx-auto mt-14 max-w-[65ch] text-[clamp(1.0625rem,1.2vw,1.1875rem)] text-secondary-foreground transition-all duration-700 ease-out delay-200 ${paragraph.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`}>Use the <b>free quote form</b>&nbsp;to request a free bathroom remodel quote in Lakeland, FL and nearby Polk County areas. Service areas can include Lakeland, Winter Haven, Bartow, Auburndale, Haines City, Davenport, Lake Wales, Mulberry, and nearby communities.</p>

            {}
            <div ref={cta.ref} className={`mt-20 transition-all duration-700 ease-out delay-300 ${cta.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`}>
              <Link to="/contact" className="group inline-flex items-center gap-2 font-default font-medium text-[0.8125rem] tracking-wider text-secondary-foreground">
                <span className="relative">
                  <span>{"Get Your Free Quote"}</span>
                  <span className="absolute right-0 bottom-0 h-px w-0 bg-secondary-foreground transition-all duration-300 ease-out group-hover:w-full" />
                </span>
                <ArrowUpLeft className="size-4" aria-hidden="true" />
              </Link>
            </div>
          </div>
        </div>

        {}
        <div className="grid grid-cols-12 mt-28 md:mt-32">
          <div ref={image.ref} className={`col-span-12 md:col-start-2 md:col-span-10 group transition-opacity ease-out ${image.isVisible ? "opacity-100" : "opacity-0"}`} style={{
          transitionDuration: "1200ms"
        }}>
            <div className="relative overflow-hidden">
              <div className="aspect-[4/5] md:aspect-[21/9] w-full overflow-hidden">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709164/img/modern_luxury_bathroom_remodel_lakeland.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709164/img/modern_luxury_bathroom_remodel_lakeland.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709164/img/modern_luxury_bathroom_remodel_lakeland.webp-wvc-sizes" alt="Modern bathroom remodel in Lakeland, Florida" loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.025]" style={{
                transitionTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)"
              }} />
              </div>
              <div className="pointer-events-none absolute -inset-4 opacity-0 transition-opacity duration-300 ease-out group-hover:opacity-100" style={{
              boxShadow: "0 0 0 1px var(--border)"
            }} aria-hidden="true" />
            </div>

            {}
            <div ref={caption.ref} className={`mt-6 flex flex-col md:flex-row md:items-baseline md:justify-between gap-2 transition-all duration-700 ease-out delay-150 ${caption.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`}>
              <p className="font-default italic text-sm md:text-[0.9375rem] text-secondary-foreground">Bathroom remodel ideas for Lakeland, FL and nearby Polk County homes.</p>
              <p className="font-default italic text-sm text-muted-foreground">Bathroom remodel quote requests near Lakeland, FL</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}